// İSG Portal — Card yüzeyi (token'lı; auth ekranları + panel kartları).

import type { HTMLAttributes } from 'react';
import { cn } from './cn';

// `carbon:rounded-none carbon:border-0 carbon:shadow-none carbon:p-4` — S33 Carbon planı
// §2.0/§2.4: Carbon "Tile" kenarlıksız/gölgesiz/köşesiz + TEK 16px dolgu, bu YAPISAL bir
// fark (radius `@theme`'de sıfırlansa bile `border`/`shadow-sm` class'ları kalıcı bir
// kenarlık/gölge ÇİZER) — bu yüzden değer override'ı yetmez, ek class gerekir. Yalnız
// `theme-carbon.css`'i import eden build'de etkili (bu dilimde yalnız Storybook).
//
// Dolgu Slice 1b'de DIŞ kaba (`Card`) taşındı — Stage 2 "CardHeader padding 0" yalnız
// `CardHeader`'ı ADLANDIRIYOR ama iki alt-bölme (`CardHeader` + `CardContent`) ayrı ayrı
// dolgu TAŞIMAYA devam ederse 16+16 = ÇİFT dolgu olurdu; bu yüzden İKİSİ de `carbon:p-0`
// olur, TEK dolgu kaynağı dış `Card` — bu tutarlılık Stage 2'nin metninde YAZILI DEĞİL,
// buradan TÜRETİLDİ (çift-dolgu bir defekt olurdu).
export function Card({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      // `data-tile` — S33 Slice 6 owner kararı, global düzeltme #2: `Input`/`Select`/
      // `SelectMenu`/`Textarea`'nın `carbon:[[data-tile]_&]:bg-field` kuralının hedeflediği
      // atasal işaret (`theme-carbon.css`'in `--color-field` yorumu, `Modal.tsx`'in footer grid
      // işareti `data-modal-footer` İLE AYNI DOM-kapsam deseni). Sade bir DOM özniteliği — yalnız
      // web-expert'in Carbon build'inde bir CSS kuralı ÜRETİR, diğer üç app'te ETKİSİZ durur.
      data-tile
      className={cn(
        'rounded-lg border border-border bg-surface shadow-sm carbon:rounded-none carbon:border-0 carbon:p-4 carbon:shadow-none',
        className,
      )}
      {...props}
    />
  );
}

export function CardHeader({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn('flex flex-col gap-1 p-6 pb-2 carbon:gap-0 carbon:p-0', className)}
      {...props}
    />
  );
}

// `as` (S33 Slice 7 QA fix, MEDIUM — `S33-7-final-qa-B.md` defekt #2): `CardTitle`
// KOŞULSUZ `<h1>` basıyordu; bir sayfanın kendi `PageHeader`'ı ZATEN o sayfanın TEK gerçek
// `<h1>`'iyken, sayfadaki HER `Card`/`CardTitle` ikinci (üçüncü, dördüncü…) bir `<h1>` daha
// ekliyordu — `/profile`'da DÖRT `<h1>` (ekran okuyucu kullanıcılarının sayfa gezinmesi için
// dayandığı "sayfa başına tek h1" iskeletini kırar). Varsayılan artık `h2` (bir `Card`ın
// başlığı normal akışta bir bölüm başlığıdır, sayfanın KENDİSİ değil); `PageHeader`sız bir
// sayfada `Card`'ın başlığı sayfanın TEK `<h1>`'İYSE çağıran `as="h1"` GEÇER (bkz. tüketici
// grep'i — web-supplier/kiosk'ta bu durumda olan sayfalar `as="h1"` aldı, diğerleri
// varsayılanı KORUDU).
export function CardTitle({
  as: Component = 'h2',
  className,
  ...props
}: HTMLAttributes<HTMLHeadingElement> & { as?: 'h1' | 'h2' | 'h3' | 'h4' }) {
  return (
    <Component
      className={cn(
        'text-xl font-semibold text-fg carbon:mb-4 carbon:text-base carbon:font-semibold carbon:leading-[22px]',
        className,
      )}
      {...props}
    />
  );
}

export function CardDescription({ className, ...props }: HTMLAttributes<HTMLParagraphElement>) {
  return <p className={cn('text-sm text-muted', className)} {...props} />;
}

export function CardContent({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return <div className={cn('p-6 pt-2 carbon:p-0', className)} {...props} />;
}
